// extracted by mini-css-extract-plugin
export default {"receptionCentersPage":"reception-centers-page_receptionCentersPage__D5-XF","styleWrapper":"reception-centers-page_styleWrapper__dQIpS"};